//RENAME THIS FILE ONCE WE KNOW MORE OF WHICH FUNCTIONS ARE HOSTED HERE
import { getLocalStorageItem, getSpId, getOrgId } from "../../utils/helpers";
import {
  SAVED_BOOKING_FORM,
  SAVE_BOOKING_FORM,
  GET_EXISTING_BOOKING,
  GOT_EXISTING_BOOKING,
  SAVE_CREDIT_CARD,
  SAVED_CREDIT_CARD,
  CHARGE_MONEY_TO_CREDIT_CARD,
  UPDATE_BOOKING_FORM,
  ERROR_SAVING_BOOKING_FORM,
  GET_UPDATED_TOKEN,
  GOT_UPDATED_TOKEN,
  GET_BOOKING_PRINTABLE_VERSION,
  GOT_BOOKING_PRINTABLE_VERSION,
  SEND_BOOKING_EMAIL,
  SENT_BOOKING_EMAIL,
  GET_SIBBLING_BOOKING,
  GOT_SIBBLING_BOOKING,
  getSibblingBooking,
  GET_PURCHASED_OFFER,
  GOT_PURCHASED_OFFER,
  SPLIT_RECURRING_APPOINTMENT
} from "../booking";
import { convertAppointmentToApiModel } from "../../utils/dataConversion";
import {
  convertAppointmentFromApiModel,
  checkRecurringClashesForDoubleBooking
} from "../../utils/dataConversion";
import {
  UPDATED_GLOBAL_ERROR_MESSAGE,
  REMOVE_GLOBAL_ERROR_MESSAGE_IF_MATCHES_THIS_STRING
} from "../globalError";
import { UPDATED_GLOBAL_SUCCESS_MESSAGE } from "../globalSuccess";
import { UPDATED_CURRENT_MENU } from "../menu";
import { menuNamesEnum } from "../../state/initialState";

import { getInvoiceApi } from "./checkoutAppointmentStep";

import { takeLatest, takeEvery } from "redux-saga/effects";
import { call, put } from "redux-saga/effects";
import { handleApiErrors, IsvalidId } from "./helpers";
import { getLocationId } from "../../utils/helpers";

let bookingPayloadToSave = {};

/***** SAGA START ******/
let sendBookingEmailApi = payload => {
  //    status : payload.data.selectedAppointmentStatusId,
  if (!IsvalidId(getSpId())) {
    return handleApiErrors({ generalError: true });
  }

  let emailBody = {
    sendemail: true,
    starttime: payload.data.starttime
  };

  if (payload.data.selectedAppointmentStatusId == 5) {
    emailBody.status = 5;
    emailBody.applyto = payload.data.applyto;
    emailBody.starttime = payload.data.starttime;
  }

  return new Promise(resolve => {
    var isuserTimeZoneSet = false;
    var interval = setInterval(() => {
      if (window.userTimezone) {
        clearInterval(interval);
        if (!isuserTimeZoneSet) {
          fetch(
            `${window.APP.apiPath}api/serviceprovider/${getSpId()}/bookings/${
              payload.data.currentBookingId
            }`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: getLocalStorageItem("token_authorization")
              },
              method: "PUT",
              body: JSON.stringify(emailBody)
            }
          )
            .then(response => {
              isuserTimeZoneSet = true;
              response.json().then(result => {
                if (result.code && result.code != 200) {
                  resolve(handleApiErrors(result));
                } else {
                  if (payload.data.cb) {
                    payload.data.cb();
                  }
                  resolve(result);
                }
              });
            })
            .catch(error => {
              logger.error(error);
              isuserTimeZoneSet = true;
              throw error;
            });
        }
      }
    }, 500);
  });
};

function* loadSentBookingEmail(dataPayload) {
  //this function loads the staff list into redux
  try {
    const data = yield call(sendBookingEmailApi, dataPayload);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: SENT_BOOKING_EMAIL, data }); // Yields effect to the reducer specifying the action type and user details
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message: window.APP.LANGUAGE.Success.SentBookingEmail,
          icon: "info"
        }
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA START ******/
let splitRecurringAppointmentApi = payload => {
  let bodyToReturn = {
    recurrence: payload.data.recurrence,
    starttime: payload.data.dateTimeOfFirstAppointmentInRecurringSeries
  };

  if (!IsvalidId(getSpId())) {
    return handleApiErrors({ generalError: true });
  }

  return new Promise(resolve => {
    var isuserTimeZoneSet = false;
    var interval = setInterval(() => {
      if (window.userTimezone) {
        clearInterval(interval);
        if (!isuserTimeZoneSet) {
          fetch(
            `${window.APP.apiPath}api/serviceprovider/${getSpId()}/bookings/${
              payload.data.currentBookingId
            }`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: getLocalStorageItem("token_authorization")
              },
              method: "PUT",
              body: JSON.stringify(bodyToReturn)
            }
          )
            .then(response => {
              isuserTimeZoneSet = true;
              response.json().then(result => {
                if (result.code && result.code != 200) {
                  resolve(handleApiErrors(result));
                } else {
                  if (payload.data.cb) {
                    payload.data.cb();
                  }
                  resolve(result);
                }
              });
            })
            .catch(error => {
              logger.error(error);
              isuserTimeZoneSet = true;
              throw error;
            });
        }
      }
    }, 500);
  });
};

function* loadSplitRecurringAppointment(dataPayload) {
  //this function loads the staff list into redux
  try {
    const data = yield call(splitRecurringAppointmentApi, dataPayload);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message: window.APP.LANGUAGE.Success.SavedBookingSuccess,
          icon: "info"
        }
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA START ******/
export let updateBookingApi = payload => {
  let bookingToSave = convertAppointmentToApiModel(
    payload.data.appointmentStepData,
    payload.data.advancedAppointmentStepData,
    payload.data.status,
    payload.data.applyto,
    payload.data.isMultiServiceAppointment,
    payload.data.gotValidOffer,
    payload.data.oldStartTime
  );
  let oldBookingToSave = null;
  if (payload.data.advancedAppointmentStepDataBeforeUserHasMadeAnyChanges) {
    oldBookingToSave = convertAppointmentToApiModel(
      payload.data.appointmentStepData,
      payload.data.advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
      payload.data.status,
      payload.data.applyto,
      payload.data.isMultiServiceAppointment,
      payload.data.gotValidOffer,
      payload.data.oldStartTime
    );
  }

  bookingPayloadToSave = bookingToSave;
  if (
    payload.data.applyto == "thisandfuture" &&
    oldBookingToSave &&
    JSON.stringify(bookingToSave.recurrence) ==
      JSON.stringify(oldBookingToSave.recurrence)
  ) {
    //check if recurrence has changed, only delete if recurrence hasnt changed
    // this is here because if we pass  recurrence it will re-generate the entire timeline
    delete bookingToSave.recurrence;
    logger.warn("recurring bug");
  }

  return new Promise(resolve => {
    var isuserTimeZoneSet = false;
    var interval = setInterval(() => {
      if (window.userTimezone) {
        window.clearInterval(interval);
        if (!isuserTimeZoneSet) {
          fetch(
            `${window.APP.apiPath}api/serviceprovider/${getSpId()}/bookings/${
              payload.data.currentBookingId
            }`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: getLocalStorageItem("token_authorization")
              },
              method: "PUT",
              body: JSON.stringify(bookingToSave)
            }
          )
            .then(response => {
              isuserTimeZoneSet = true;
              response.json().then(result => {
                if (result.code && result.code != 200) {
                  resolve(handleApiErrors(result));
                } else {
                  if (payload.data.cb) {
                    payload.data.cb();
                  }
                  resolve(
                    convertAppointmentFromApiModel(
                      result,
                      payload.data.appointmentStepData,
                      payload.data.advancedAppointmentStepData,
                      window.userTimezone,
                      false,
                      true
                    )
                  );
                }
              });
            })
            .catch(error => {
              logger.error(error);
              isuserTimeZoneSet = true;
              throw error;
            });
        }
      }
    }, 500);
  });
};

function* loadUpdatedBooking(bookingToSave) {
  //this function loads the staff list into redux
  try {
    const data = yield call(updateBookingApi, bookingToSave);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
      let { responseData } = data;
      responseData = checkRecurringClashesForDoubleBooking(
        bookingPayloadToSave,
        responseData,
        bookingToSave.data.appointmentStepData
      );
      yield put({ type: ERROR_SAVING_BOOKING_FORM, data: responseData });
      if (responseData && responseData.timeNotAvailable) {
        yield put({
          type: UPDATED_CURRENT_MENU,
          data: menuNamesEnum.SECOND_STEP_ADVANCED
        });
      }
    } else {
      yield put({ type: SAVED_BOOKING_FORM, data }); // Yields effect to the reducer specifying the action type and user details
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message: window.APP.LANGUAGE.Success.SavedBookingSuccess,
          icon: "saved_icon"
        }
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA START ******/
export let saveBookingApi = payload => {
  let bookingToSave = convertAppointmentToApiModel(
    payload.data.appointmentStepData,
    payload.data.advancedAppointmentStepData,
    payload.data.status,
    payload.data.applyto,
    payload.data.isMultiServiceAppointment,
    payload.data.gotValidOffer
  );
  bookingPayloadToSave = bookingToSave;

  return new Promise(resolve => {
    var isuserTimeZoneSet = false;
    var interval = setInterval(() => {
      if (window.userTimezone) {
        clearInterval(interval);
        if (!isuserTimeZoneSet) {
          fetch(
            `${window.APP.apiPath}api/serviceprovider/${getSpId()}/bookings`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: getLocalStorageItem("token_authorization")
              },
              method: "POST",
              body: JSON.stringify(bookingToSave)
            }
          )
            .then(response => {
              isuserTimeZoneSet = true;
              response.json().then(result => {
                if (result.code && result.code != 200) {
                  resolve(handleApiErrors(result));
                } else {
                  if (payload.data.cb) {
                    payload.data.cb();
                  }
                  resolve(
                    convertAppointmentFromApiModel(
                      result,
                      payload.data.appointmentStepData,
                      payload.data.advancedAppointmentStepData,
                      window.userTimezone
                    )
                  );
                }
              });
            })
            .catch(error => {
              logger.error(error);
              isuserTimeZoneSet = true;
              throw error;
            });
        }
      }
    }, 500);
  });
};

function* loadSavedBooking(payload) {
  //this function loads the staff list into redux
  try {
    const data = yield call(saveBookingApi, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
      let { responseData } = data;
      responseData = checkRecurringClashesForDoubleBooking(
        bookingPayloadToSave,
        responseData,
        payload.data.appointmentStepData
      );
      yield put({ type: ERROR_SAVING_BOOKING_FORM, data: responseData });
      if (responseData && responseData.timeNotAvailable) {
        yield put({
          type: UPDATED_CURRENT_MENU,
          data: menuNamesEnum.SECOND_STEP_ADVANCED
        });
      }
    } else {
      yield put({ type: SAVED_BOOKING_FORM, data }); // Yields effect to the reducer specifying the action type and user details
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message: window.APP.LANGUAGE.Success.SavedBookingSuccess,
          icon: "saved_icon"
        }
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA START ******/
export let getBookingApi = payload => {
  if (!IsvalidId(payload.bookingId)) {
    return handleApiErrors({ generalError: true });
  }

  return new Promise(resolve => {
    var isuserTimeZoneSet = false;
    let handler = () => {
      if (!isuserTimeZoneSet) {
        fetch(`${window.APP.apiPath}api/bookings/${payload.bookingId}`, {
          headers: { Authorization: getLocalStorageItem("token_authorization") }
        })
          .then(response => {
            isuserTimeZoneSet = true;
            response.json().then(result => {
              if (result.code && result.code != 200) {
                resolve(handleApiErrors(result));
              } else {
                if (payload.data.cb) {
                  payload.data.cb();
                }
                resolve(result);
              }
            });
          })
          .catch(error => {
            logger.error(error);
            isuserTimeZoneSet = true;
            throw error;
          });
      }
    };

    if (!window.userTimezone) {
      var interval = setInterval(() => {
        if (window.userTimezone) {
          clearInterval(interval);
          handler();
        }
      }, 500);
    } else {
      handler();
    }
  });
};

function* loadExistingBooking({ payload }) {
  try {
    let data = yield call(getBookingApi, payload);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      if (!data.appointmentStepData) {
        data = convertAppointmentFromApiModel(
          data,
          payload.data.appointmentStepData,
          payload.data.advancedAppointmentStepData,
          window.userTimezone
        );
      }
      if (data.checkoutAppointmentStepData.invoiceKey) {
        const invoiceResult = yield call(
          getInvoiceApi,
          data.checkoutAppointmentStepData
        );
        if (!invoiceResult || invoiceResult.error) {
          yield put(invoiceResult.error); // Yields effect to the reducer specifying the action type and user details
        } else {
          data.invoiceData = invoiceResult || {};
        }
      }
      yield put({ type: GOT_EXISTING_BOOKING, data });
      if (
        data.sibblingBookingIds &&
        data.sibblingBookingIds.length > 0 &&
        !payload.data.appointmentStepData
          .triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
      ) {
        data.sibblingBookingIds.map((o, i) => {
          setTimeout(() => {
            payload.bookingId = o.id;

            window.dispatch(getSibblingBooking(payload));
          }, 1); // each dispatch has to be executed on its own loop
        });
      }
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA START ******/

let getSibblingApi = payload => {
  return fetch(`${window.APP.apiPath}api/bookings/${payload.bookingId}`, {
    headers: { Authorization: getLocalStorageItem("token_authorization") }
  })
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (payload.data.cb) {
            payload.data.cb();
          }
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadSibblingBooking({ payload }) {
  try {
    let data = yield call(getSibblingApi, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      let isSibling = true;
      data = convertAppointmentFromApiModel(
        data,
        payload.data.appointmentStepData,
        payload.data.advancedAppointmentStepData,
        window.userTimezone,
        isSibling
      );
      if (data.checkoutAppointmentStepData.invoiceKey) {
        const invoiceResult = yield call(
          getInvoiceApi,
          data.checkoutAppointmentStepData
        );
        if (!invoiceResult || data.error) {
          yield put(data.error); // Yields effect to the reducer specifying the action type and user details
        } else {
          data.invoiceData = invoiceResult || {};
        }
      }
      yield put({ type: GOT_SIBBLING_BOOKING, data });
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA START ******/
let saveCreditCardApi = (payload, bookingId) => {
  //stipe token with no charge amount saves the card
  if (payload.chargeamount) {
    console.error("chargeamount provided, this will not save the credit card");
  }
  if (!IsvalidId(getSpId())) {
    return handleApiErrors({ generalError: true });
  }

  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/bookings/${bookingId}`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization")
      },
      method: "PUT",
      body: payload,
      Accept: "application/vnd.manager-v2+json",
      "Content-Type": "application/vnd.manager-v2+json"
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadSavedCreditCard(payload, bookingId) {
  //this function loads the staff list into redux
  try {
    const data = yield call(saveCreditCardApi, payload, bookingId);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: SAVED_CREDIT_CARD, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA START ******/
let chargeMoneyToCreditCardApi = (payload, bookingId) => {
  //stipe token with no charge amount saves the card
  if (!payload.chargeamount) {
    console.error(
      "chargeamount was not provided, card will be saved but not charged"
    );
  }
  if (!IsvalidId(getSpId())) {
    return handleApiErrors({ generalError: true });
  }

  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/bookings/${bookingId}`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization")
      },
      method: "PUT",
      body: payload,
      Accept: "application/vnd.manager-v2+json",
      "Content-Type": "application/vnd.manager-v2+json"
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadChargeMoneyToCreditCardResult(payload, bookingId) {
  //this function loads the staff list into redux
  try {
    const data = yield call(chargeMoneyToCreditCardApi, payload, bookingId);

    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: CHARGED_MONEY_TO_CREDIT_CARD, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA START ******/

let getPurchasedOfferApi = offerId => {
  if (!IsvalidId(getSpId())) {
    return handleApiErrors({ generalError: true });
  }

  return fetch(
    `${
      window.APP.apiPath
    }api/serviceprovider/${getSpId()}/offerpurchases/${offerId}`,
    {
      headers: { Authorization: getLocalStorageItem("token_authorization") }
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (result.found == false) {
            return handleApiErrors({ reasons: "offernotfound" });
          } else {
            return result;
          }
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadPurchasedOffer({ offerId }) {
  //this function loads the staff list into redux
  try {
    const data = yield call(getPurchasedOfferApi, offerId);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      if (
        data.found &&
        data.purchase &&
        data.purchase.status &&
        data.purchase.status.description == "redeemed"
      ) {
        yield put({
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: {
            message: window.APP.LANGUAGE.Errors.OfferAlreadyRedeemed,
            icon: "info"
          }
        }); // Yields effect to the reducer specifying the action type and user details
      } else {
        yield put({
          type: REMOVE_GLOBAL_ERROR_MESSAGE_IF_MATCHES_THIS_STRING,
          data:
            window.APP.LANGUAGE.Errors
              .OffersKeywordFoundInErrorAppointmentMessages
        });
        yield put({ type: GOT_PURCHASED_OFFER, data }); // Yields effect to the reducer specifying the action type and user details
      }
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA END ******/

export let updateTokenApi = () => {
  //stipe token with no charge amount saves the card
  return fetch(`${window.APP.apiPath}token`, {
    headers: {
      Authorization: getLocalStorageItem("token_authorization")
    },
    method: "GET"
  })
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadUpdatedToken() {
  try {
    const data = yield call(updateTokenApi);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_UPDATED_TOKEN, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

/***** SAGA END ******/

let getBookingPrintableVersionApi = payload => {
  //stipe token with no charge amount saves the card
  return fetch(
    `${window.APP.apiPath}bookingload.action?calendarentryid=${payload.bookingId}`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization")
      },
      method: "GET"
    }
  )
    .then(response => {
      return response.blob().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadBookingPrintableVersion(bookingId) {
  try {
    const data = yield call(getBookingPrintableVersionApi, bookingId);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_BOOKING_PRINTABLE_VERSION, data }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}

/***** SAGA END ******/

function* watchRequests() {
  yield* [
    takeLatest(SAVE_BOOKING_FORM, loadSavedBooking),
    takeEvery(GET_SIBBLING_BOOKING, loadSibblingBooking),
    takeLatest(UPDATE_BOOKING_FORM, loadUpdatedBooking),
    takeLatest(GET_BOOKING_PRINTABLE_VERSION, loadBookingPrintableVersion),
    takeLatest(SEND_BOOKING_EMAIL, loadSentBookingEmail),
    takeLatest(GET_EXISTING_BOOKING, loadExistingBooking),
    takeLatest(GET_PURCHASED_OFFER, loadPurchasedOffer),
    takeLatest(GET_UPDATED_TOKEN, loadUpdatedToken),
    takeLatest(SPLIT_RECURRING_APPOINTMENT, loadSplitRecurringAppointment)
  ];
}

export default [watchRequests];
